import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const BilinearTransformation = () => (
  <QPhototModuleSubtopic
    title="Bilinear transformation"
    videos={[
      "https://www.youtube.com/embed/fQQEPhmml6o?t=402",
      "https://www.youtube.com/embed/VFIaGUb1Fqg",
      "https://www.youtube.com/embed/HArqIvUDhzQ"
    ]}
    takeaways={[]}
    questions={[
      { text: "Find the bilinear transformation which maps z = 0 onto w = -i and has -1 and 1 as the invariant points. Also, show that under this transformation the upper half of the z-plane maps onto the interior of the unit circle in the w-plane." },
      { text: "Determine the bilinear transformation that maps the points 1, i, -1 in the z-plane into the points 2, i, -2 respectively in the w-plane. Also, find its invariant points." },
      {image:"/cvla_16.png"},
      {image:"/cvla_17.png"},
      {image:"/cvla_18.png"},
      {image:"/cvla_19.png"},
    ]}
    exampleVideos={[]}
  />
);

export default BilinearTransformation;
